import { ar as e } from "./locales/ar.js";
import { de as t } from "./locales/de.js";
import { en as n } from "./locales/en.js";
import { es as r } from "./locales/es.js";
import { fr as i } from "./locales/fr.js";
import { pt as a } from "./locales/pt.js";
import { ru as o } from "./locales/ru.js";
import { zhCn as s } from "./locales/zh-cn.js";
import { zhTw as c } from "./locales/zh-tw.js";
//#region src/schema/localization/translations.ts
var l = {
	en: n,
	de: t,
	es: r,
	fr: i,
	pt: a,
	ru: o,
	ar: e,
	"zh-CN": s,
	"zh-TW": c
};
//#endregion
export { l as schemaTranslations };

//# sourceMappingURL=translations.js.map